import Skeleton from '@/shared/Loaders/Skeleton'
import css from './notificationCenterCardSkeleton.module.css'
import { CSSProperties } from 'react'

interface IProps {
  wrapperStyle?: CSSProperties
}

const NotificationCenterCardSkeleton = (props: IProps) => {
  return (
    <div className={css.wrapper} style={props.wrapperStyle}>
      <Skeleton width="32px" height="32px" style={{ borderRadius: '50%' }} />
      <div className="flex-lines gap4" style={{ width: '100%', height: '120px' }}>
        <Skeleton width="75%" height="22px" />
        <Skeleton width="50%" height="22px" />
        <Skeleton style={{ marginTop: '8px' }} width="25%" height="16px" />
        <Skeleton style={{ marginTop: '8px' }} width="50%" height="32px" />
      </div>
    </div>
  )
}

export default NotificationCenterCardSkeleton
